<template>
  <div id="app">
    <div class="l-page">
      <Header />
      <router-view />
      <Footer />
    </div>
  </div>
  <MessageDialog />
</template>

<script lang="ts">
import { defineComponent, onMounted } from 'vue'
import Header from '@/components/common/Header.vue'
import Footer from '@/components/common/Footer.vue'
import { useI18n } from 'vue-i18n'
import { setLocale } from '@vee-validate/i18n'
import MessageDialog from '@/components/common/dialog/MessageDialog.vue'

export default defineComponent({
  name: 'App',
  setup() {
    const lang = useI18n()
    onMounted(() => {
      // ブラウザバック・フォワードで画面遷移するとChromeではbfcacheにより言語設定が復元されてしまい、不一致が発生するためタブリロードする。
      performance.getEntriesByType('navigation').forEach(pe => {
        switch ((pe as PerformanceNavigationTiming).type) {
          case 'back_forward':
            window.location.reload()
            break
          default:
            break
        }
      })
      // 初回アクセス時にユーザーのブラウザの言語に応じて言語を変更する
      if (window.navigator.language.slice(0, 2) === 'ja') {
        lang.locale.value = 'ja'
        setLocale('ja')
      } else {
        lang.locale.value = 'en'
        setLocale('en')
      }
    })
  },
  components: {
    Header,
    Footer,
    MessageDialog,
  },
})
</script>

<style lang="scss"></style>
